var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5H20M4 8.5V17.3002C4 18.4203 4 18.9801 4.21799 19.4079C4.40973 19.7842 4.71547 20.0905 5.0918 20.2822C5.5192 20.5 6.07899 20.5 7.19691 20.5H16.8031C17.921 20.5 18.48 20.5 18.9074 20.2822C19.2837 20.0905 19.5905 19.7842 19.7822 19.4079C20 18.9805 20 18.4215 20 17.3036V8.5M4 8.5V7.7002C4 6.58009 4 6.01962 4.21799 5.5918C4.40973 5.21547 4.71547 4.90973 5.0918 4.71799C5.51962 4.5 6.08009 4.5 7.2002 4.5H8M20 8.5V7.69691C20 6.57899 20 6.0192 19.7822 5.5918C19.5905 5.21547 19.2837 4.90973 18.9074 4.71799C18.4796 4.5 17.9203 4.5 16.8002 4.5H16M8 4.5H16M8 4.5V2.5M16 4.5V2.5M16 12.5H8",
    stroke: "#1F284E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWeek);
export default __webpack_public_path__ + "static/media/Calendar_Week.c0913f5558f897c1c32fead466d5f065.svg";
export { ForwardRef as ReactComponent };